module.exports = __webpack_public_path__ + "img/avatar3.b9361925.jpg";